"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.562 12.148c-.35-.19-.714-.18-1.038-.067-.317.11-.605.317-.84.54A567.695 567.695 0 0 0 24 21.096a567.541 567.541 0 0 0-8.684-8.473c-.235-.224-.523-.432-.84-.541-.324-.112-.688-.123-1.038.067a3.197 3.197 0 0 0-.73.56 3.203 3.203 0 0 0-.56.73c-.19.35-.18.714-.067 1.038.11.317.317.605.54.84A567.203 567.203 0 0 0 21.096 24a567.917 567.917 0 0 0-8.473 8.684c-.224.235-.432.523-.541.84-.112.324-.123.688.067 1.038a3.2 3.2 0 0 0 .56.73c.257.258.504.437.73.56.35.19.714.18 1.038.067.317-.11.605-.317.84-.54A567.394 567.394 0 0 0 24 26.904a567.394 567.394 0 0 0 8.684 8.473c.235.224.523.432.84.541.324.112.688.123 1.038-.067a3.19 3.19 0 0 0 .73-.56 3.2 3.2 0 0 0 .56-.73c.19-.35.18-.714.067-1.038-.11-.317-.317-.605-.54-.84A566.715 566.715 0 0 0 26.904 24a567.71 567.71 0 0 0 8.473-8.684c.224-.235.432-.523.541-.84.112-.324.123-.688-.067-1.038a3.2 3.2 0 0 0-.56-.73 3.2 3.2 0 0 0-.73-.56Z",
    fill: "#FF611D"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgError);
var _default = exports["default"] = Memo;